// src/components/CustomSingleTimePicker.tsx
import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

type CustomSingleTimePickerProps = {
  name: string;
  control: Control<any>;
  label?: string;
};

const CustomSingleTimePicker: React.FC<CustomSingleTimePickerProps> = ({
  name,
  control,
  label = 'Select Time',
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <TimePicker
            label={label}
            value={field.value || null}
            onChange={(newValue: any) => field.onChange(newValue)}
            slotProps={{
              textField: {
                fullWidth: true,
                error: !!fieldState.error,
                helperText: fieldState.error?.message,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomSingleTimePicker;
